import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const getFeedbacksFunc = createAsyncThunk(
  "feedbacks/getAll",
  async () => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/feedbacks`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result)
        return result;
      })
      .catch((error) => {
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const getFeedbacksSlicer = createSlice({
  name: "get feedbacks Slicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getFeedbacksFunc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFeedbacksFunc.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "fetched successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(getFeedbacksFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default getFeedbacksSlicer.reducer;
